module.exports = __webpack_public_path__ + "img/P1000881.ebb51696.jpg";